<template>
    <div id='forgotbox'>
        <div class="top">
          <div class="forgot_top" @click="gologin">
            <!-- <img src="../../assets/login/xinghezuo.png" alt="" class="titleimg"> -->
            <div class="title_left">
              <img src="../../assets/logo2.png" alt="" class="titleimg"  @click="gotibao">
              <div class="line"></div>
            <span>大数据合作平台</span>
          </div>
          </div>
        </div>
        <div class="contentbox">
          <div class="break_tit"><span class="yuan"></span><span @click="gologin" class="gologin_btn">首页</span> > {{pagename==1?'忘记密码':'修改密码'}}</div>
          <div class="step_bar">
              <div class="step_bar_in">
                  <div class="step_bar_item">
                      <span :class="step_num1 == 1 ? 'numberBox': 'numberBoxgroy'">1</span>
                      <span class="step_tit_txt">填写账户信息</span>
                  </div>
                  <div :class="step_num2 == 2 ? 'step_bar_item':'step_bar_item_noborder'">
                      <span :class="step_num2 == 2 ? 'numberBox': 'numberBoxgroy'">2</span>
                      <span class="step_tit_txt">验证信息</span>
                  </div>
                  <div :class="step_num3 == 3?'step_bar_item':'step_bar_item_noborder'">
                      <span :class="step_num3 == 3 ? 'numberBox': 'numberBoxgroy'">3</span>
                      <span class="step_tit_txt">修改密码</span>
                  </div>
                  <div :class="step_num4 == 4?'step_bar_item':'step_bar_item_noborder'">
                      <span :class="step_num4 == 4 ? 'numberBox': 'numberBoxgroy'">4</span>
                      <span class="step_tit_txt">完成</span>
                  </div>
              </div>
          </div>
          <div class="content">
            <el-form :model="formdata" label-width="100px" :rules="rules"  class="formdata forget-tel" v-if='step_start' ref='form'>
              <el-form-item  prop="tel" class="tel" label='手机号'>
                <el-input prefix-icon="el-icon-user" type="number" v-model="formdata.tel" :disabled="istel" maxlength="11" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item  prop="imgcode" class="codeBox" label='图形验证码'>
                <el-input prefix-icon="el-icon-key" type="text" v-model="formdata.imgcode" placeholder="请输入右侧验证码" class="code"></el-input>
                <img class="imgcode" :src='imgcodeUrl' @click="refreshCode" ref='img'>
              </el-form-item>
              <el-button class="next_step2"  type="primary" @click="step2Handel">下一步</el-button>
            </el-form> 
            <el-form :model="formdata" label-width="100px" :rules="rules" class="formdata" ref='form1' v-if='step2_flag'>
              <div class="havesendTip">
                <img src="../../assets/forgot/icon_yes.png" alt="" class="icon_yes">
                <span>向您绑定的手机{{tel_num}}发送短信验证码</span>
              </div>
              <el-form-item  prop="numcode" class="codeBox phonebox" label='手机验证码' label-width="100px">
                <el-input prefix-icon="el-icon-key" type="number" v-model="formdata.numcode" placeholder="请输入短信验证码" class="code"></el-input>
                <div class="numcode" @click="getcode" v-if='codeflag == 1'>获取手机验证码</div>
                <div class=" dis_numcode" v-if='codeflag == 2'>{{codetime}}秒后重新获取</div>
              </el-form-item>
              <div class="niImgcodeTip" v-if='niImgcodeTip_flag'>{{numcodeerrer}}</div>
              <!-- <div class="next_step2 next_step3" @click="step3Handel">下一步</div> -->
              <el-button class="next_step2"  type="primary" @click="step3Handel">下一步</el-button>
            </el-form>
            <el-form :model="formdata" label-width="100px" :rules="rules" class="formdata"  ref='form2' v-if='step3_flag'>
              <el-form-item  prop="password" class="password" label="新密码">
                <el-input prefix-icon="el-icon-lock" type="password" v-model="formdata.password" placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item  prop="surepassword" class="surePassword" label="确认密码">
                <el-input prefix-icon="el-icon-lock" type="password" v-model="formdata.surepassword" placeholder="确认密码"></el-input>
              </el-form-item> 
              <!-- <div class="next_step2" @click="step4Handel">下一步</div> -->
              <el-button class="next_step2"  type="primary" @click="step4Handel">下一步</el-button>
            </el-form> 
            <div v-if='step4_flag'>
              <div class="success_img_box">
                  <img src="../../assets/forgot/icon_yes.png" alt="" class="success_img">
              </div>
              <div class="success_txt">恭喜！您的密码已经修改成功</div>
              <el-button  type="primary" class="next_step2" @click="gologin">登录</el-button>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import http from '@/utils/http.js'
export default {
    data(){
        let validateTel = (rule, value, callback) => {
        if(value.length > 0){
          let rex = /^1[23456789]\d{9}$/;
          if(!rex.test(value)){
            this.step1_flag = false;
            callback(new Error('手机号格式错误'));
          }else {
            //  this.step1_flag = true;
             callback();
          }
        }
        callback(); 
        };
        let validateImgcode = (rule, value, callback) => {
            if(value) {
              this.n = 1;
              let data={code: this.formdata.imgcode,sid:this.$http.cookie.get('PHPSESSID')};
              this.$httplogin({
                  method: 'GET',
                  url: '/check',
                  params: data,
              }).then((res) => {
              if(res.code == 1){
                  this.step1_flag = true; 
                  this.imgcode_flag = true;
                  callback();
              }else {
                  this.step1_flag = false;
                  this.imgcode_flag = false;
                  callback(new Error('验证码错误'));
              }
              }).catch((err) => {
                callback(new Error('验证码错误'));
              })
            }
        };
        let validateNumcode = (rule, value, callback) => {
            callback(); 
        };
        let validatePass = (rule, value, callback) => {
            if(value.length < 6 || value.length > 24){
            callback(new Error('密码长度应为6~24位'));     
            }
            callback(); 
        };
        let validatePass2 = (rule, value, callback) => {
            if(value != this.formdata.password){
            callback(new Error('两次输入的密码不一致'));     
            }else {
              callback();  
            }
            
        };
        return{
            istel: false,
            formdata: {
                tel:'',
                imgcode:'',
                numcode:'',
                password: '',
                surepassword:'',
            },
            rules:{
                tel: [
                  {
                  required: true,
                  message: "手机号不能为空",
                  trigger:'blur'
                },{
                    validator: validateTel,
                    trigger:'blur'
                }],
                imgcode: [
                  {
                  required: true,
                  message: "图形验证码不能为空",
                  trigger:'blur'
                },{
                    validator: validateImgcode,
                    trigger:'blur'
                }],
                numcode: [
                  {
                  required: true,
                  message: "验证码不能为空",
                  trigger:'blur'
                },{
                    validator: validateNumcode,
                    trigger:'blur'
                }],
                password: [
                   {
                  required: true,
                  message: "密码不能为空",
                  trigger:'blur'
                },{
                    validator: validatePass,
                    trigger:'blur'
                }],
                surepassword: [
                 {
                  required: true,
                  message: "确认密码不能为空",
                  trigger:'blur'
                },{
                    validator: validatePass2,
                    trigger:'blur'
                }],
            },
            imgcodeUrl: '',
            codeflag: 2,
            codetime: 60,//验证码倒计时
            tel_num:'',
            step_num1: 1,
            step_num2: 0,
            step_num3: 0,
            step_num4: 0,
            step_start: true,
            step1_flag: true,
            step2_flag: false,
            step3_flag: false,
            step4_flag: false,
            n: 0,
            niImgcodeTip_flag: false,
            numcodeerrer:'',
            validateImgcode: validateImgcode,
            imgcode_flag: false,
            routerAddress:'',
            address:'',
            pagename:''
            // entrance:''


        }
    },
    name: 'forgotpassword',
    components: {
    },
    created(){
      if(this.$route.query.address){
        this.address = this.$route.query.address;
        this.pagename=this.$route.query.pagename
      }else {
        this.routerAddress = this.$route.query.routerAddress;
        this.pagename=this.$route.query.pagename;
        this.formdata.tel = http.cookie.get('user_info').tel;
        this.istel = true;
      }

    },
    mounted(){
      this.imgcodeUrl = 'https://xingluoapi.linkstars.com/verify?t='+ Math.random()
    },
    methods:{
        // 刷新验证码
        refreshCode(){
            this.$refs.img.src='https://xingluoapi.linkstars.com/verify?t='+ Math.random()
        },
         // 获取手机号验证码
        getcode(){
          let that = this; 
          let data={
              tel: that.formdata.tel,
              type: 1,
          };
          that.$httplogin({
              method: 'POST',
              url: '/home/sendCode',
              data: data,
          }).then((res) => {
              let  tel_num = (this.formdata.tel).substr(0,3) + '****' + (this.formdata.tel).substr(7,4);
              that.tel_num  = tel_num;       
              if(res && res.code ==1){
                  that.$message({
                    message:'发送成功',
                    type: 'success'
                  });
                  that.step2_flag = true;
                  that.step_start = false;
                  that.step_num2 = 2;
              }else if(res.code == 400){
                  that.$message(res.data);
              }else {
                that.$message(res.data);
              }
              that.timejs();
          })
        },
          // 验证码倒计时
        timejs(){
          let that = this;
          that.codeflag = 2;
          var timer = setTimeout(function(){
              if(that.codetime <=0){
                that.codetime = 60
                that.codeflag = 1;
                clearTimeout(that.timer)
              }else {
                that.codetime -=1;
                if(that.codetime <10){
                    that.codetime = '0' + that.codetime
                }  
                that.timejs()
              }
              
          },1000)
        },
         gologin(){
            let params = ''
            if(this.routerAddress) {
              window.location.href = `https://xl.linkstars.com/admin/#/login?routerAddress=${this.routerAddress}&type=login`
            }else {
              if(this.address){
                window.location.href = `https://xl.linkstars.com/admin/#/login?address=${this.address}&type=login`
              }else {
                window.location.href = `https://xl.linkstars.com/admin/#/login?type=login`                
              }
            }
         },
        gotibao(){
          window.location.href=`https://www.linkstars.com`;
        },
        // 前往第二步
        step2Handel (){
          let that = this;
          if(that.n == 1){
          that.rules.imgcode = [];            
          }
           that.$refs.form.validate((valid) => {
                that.rules.imgcode = [{//点击完注册在重新添加进去
                  required: true,
                  message: "图形验证码不能为空",
                  trigger:'blur'
                },
                  {
                  validator: that.validateImgcode,
                  trigger:'blur'
                }]
             if(valid){
                // if(!that.imgcode_flag){
                //   return;
                // }
                if(that.step1_flag) {
                  that.getcode();       
                }
             } 
           })
        },
        // 前往第三部
        step3Handel(){
          let that = this;
          that.$refs.form1.validate((valid) => {
            if(valid){
              let data = {
                      code: that.formdata.numcode,
                      tel:that.formdata.tel
                    };
              that.$http({
                    method: 'GET',
                    url: '/check',
                    params: data,
                }).then((res) => {
                if(res.code == 1){
                    that.step3_flag = true; 
                    that.step2_flag = false;
                    that.step_num3 = 3;
                    that.niImgcodeTip_flag = false;
                }else {
                    that.numcodeerrer = res.msg;
                    that.niImgcodeTip_flag = true;
                    that.step3_flag = false;
                }
              })
            }
          })
        },
        // 前往第四部
        step4Handel(){
          let that = this;
          that.$refs.form2.validate((valid) => {
            if(valid){
              let data = {
                      tel: that.formdata.tel,
                      password:that.formdata.password
                    };
              that.$http({
                    method: 'POST',
                    url: '/home/changePassword',
                    data: data,
                }).then((res) => {
                if(res.code == 1){
                    this.step3_flag = false;
                    this.step4_flag = true;
                    this.step_num4 = 4;
                }else if(res.code == 400){
                    this.$message(res.data);
                }else {
                  this.$message(res.data);
                }
              })
            }
          }) 
         
        }
      },
    }
</script>

<style scoped>
  .top {
    height:100px;
    box-shadow:  0 2px 11px 0 rgba(215,215,215,0.50);
  }
  .forgot_top {
    width: 1190px;
    height: 100px;
    padding: 15px 0;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .title_left {
    display: flex;
    align-items: center;
  }
  .line {
    width: 2px;
    height: 29px;
    background-color: #f1f1f1;
    margin: 0 15px;
  }
  .title_left span{
    font-size: 20px;
    color: #333;
  }
  .titleimg {
    width: 124px;
    cursor: pointer;
  }
  .contentbox{
    width: 1190px;
    margin: 0 auto;
    /* text-align: center; */
  }
  .break_tit {
    font-size: 14px;
    color: #909399; 
    margin-top: 37px;
  }
  .yuan {
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: #FD9635 ;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 6px;
    margin-top: -3px;
  }
  .step_bar {
    /* padding: 0 93px; */
    margin-top: 55px;
  }
  .step_bar_in {
    border-bottom: 2px solid #F2F6FC;
    padding: 0  66px;
    display: flex;
  }
  .numberBox {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    background: #6435E8;
    color: #fff;
    border-radius: 50%;
    font-size: 16px;
    text-align: center;
    vertical-align: middle;
    margin-right: 20px;
    margin-top:-5px;
  }
  .numberBoxgroy {
   display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    background: #999;
    color: #fff;
    border-radius: 50%;
    font-size: 16px;
    text-align: center;
    vertical-align: middle;
    margin-top: -5px;
    margin-right: 20px;
  }
  .step_bar_item {
    padding: 0 35px 15px 35px;
    box-sizing: border-box;
    white-space: nowrap;
    flex: 1;
    text-align: center;
    border-bottom: 2px solid #6435E8;
  }
  .step_bar_item_noborder {
    padding: 0 35px 15px 35px;
    box-sizing: border-box;
    white-space: nowrap;
    flex: 1;
    text-align: center;
    border-bottom: 0; 
  }
  .step_tit_txt {
    color: #303133;
    font-size: 20px;
    font-weight: 700;
  }
  /* 第一步 */
  .tel {
    width: 481px;
    margin: 0 auto;
    margin-top: 112px;
  }
  .codeBox {
    width: 481px;
    margin: 0 auto;
    position: relative;
    top: 15px;
    /* overflow: hidden; */
    /* left: 50%;
    top: 15px;
    transform: translate(-50%); */
  }
  .code {
    width: 255px;
    /* position: absolute;
    left: 0;
    top:0; */

  }
  .imgcode,.numcode,.dis_numcode{
    width: 119px;
    height: 50px;
    line-height: 50px;
    margin-top: 15px;
    position: absolute;
    right: 0;
    top:-15px;
    border-radius: 2px;
  }
  .imgcode {
    cursor: pointer;
  }
  .phonebox {
    margin-top: 49px;
  }
  .next_step2 {
    width: 381px;
    height: 52px;
    color: #fff;
    font-size: 20px;  
    text-align: center;
    position: relative;
    top: 45px;
    left: 50%;
    transform: translate(-37%);
  }
   .numcode {  
    background-color: #6435E8;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
  }
   .dis_numcode{
    text-align: center;
    background-color: #ccc;
  }
  .icon_yes {
    width: 16px;
    height: 16px; 
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px; 
    margin-top: -3px;
  }
  .havesendTip {
    width:100%;
    font-size: 18px;
    color: #303133;
    text-align: center;
    margin-top: 71px;
  }
  .next_step3 {
    width: 170px; 
    /* margin-left: -65px; */
  }
  .password,.surePassword {
    width: 481px;
    margin: 0 auto;
  } 
  .password{
    margin-top: 112px;
    margin-bottom: 15px;
  }
  .success_img_box {
    margin-top: 81px;
    margin-bottom: 19px;
    text-align: center;
    margin-left: 96px;
  }
  .success_img {
   width: 60px;
   height: 60px;  
  }
  .success_txt {
    font-size: 14px;
    color: #303133; 
    text-align: center; 
    margin-left: 96px;
  }
   .niImgcodeTip {
    color: #F56C6C;
    font-size: 12px;
    margin-top: -20px;
    text-align: center;
    margin-top: 20px;
    margin-left: -235px;
  }
  .gologin_btn {
    cursor: pointer;
  }
  .gologin_btn:hover{
    color: #6435E8;
  }

</style>
<style>
  #forgotbox  .forget-tel .el-form-item__label{
    height:50px;
    line-height:50px;
  }
</style>
